import { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { getFeatures, isFeatureOn } from '../services/features.js';

/**
 * Renders its children only while the named runtime feature flag is on
 * (GET /api/brand `features`); when the server says off, the route behaves as
 * if it does not exist and lands on the app's default page.
 *
 * Waits for the ANSWER before rendering, unlike the nav (which fails open
 * immediately): a hidden page flashing for half a second during a demo is the
 * exact thing the flag exists to prevent, and the /api/brand response is
 * already cached by the time any route renders.
 */
export default function FeatureGate({ flag, children }) {
  const [features, setFeatures] = useState(null);
  useEffect(() => {
    let alive = true;
    getFeatures().then((f) => alive && setFeatures(f));
    return () => { alive = false; };
  }, []);
  if (features === null) return null; // resolving — almost always instant
  if (!isFeatureOn(features, flag)) return <Navigate to="/" replace />;
  return children;
}
